import { Package, Smartphone, Check, ClipboardList, QrCode, MessageCircle } from "lucide-react";
import { CaixaRegistradoraIcon, MesaIcon, MotoEntregaIcon, TotemIcon } from "@/components/icons/ModulosIcons";

/**
 * Os 7 módulos da campanha, cada um liga e desliga (dono, 26/10/2026). O `id`
 * é o `pedidos.modulo` de cada canal (backend: campaigns/review_regras.py).
 * Os presenciais só recebem se o cliente escreveu para a loja no WhatsApp nos
 * últimos 30 dias — puxar conversa fria é o que bloqueia o número.
 */
export const MODULOS = [
  { id: "Cardapio", label: "Cardápio Digital", icon: Smartphone },
  { id: "Delivery", label: "Delivery", icon: MotoEntregaIcon },
  { id: "Mesas", label: "Mesas", icon: MesaIcon, presencial: true },
  { id: "Balcao", label: "Balcão", icon: CaixaRegistradoraIcon, presencial: true },
  { id: "Totem", label: "Totem", icon: TotemIcon, presencial: true },
  { id: "Comandas", label: "Comandas", icon: ClipboardList, presencial: true },
  { id: "MesaQR", label: "Mesa QR Code", icon: QrCode, presencial: true },
];

export function ModuleCards({ value = [], onToggle }) {
  return (
    <section>
      <div className="flex items-center gap-1.5 mb-1">
        <Package className="w-4 h-4 text-amber-600" />
        <h3 className="text-sm font-bold">Enviar para pedidos de</h3>
      </div>
      <p className="text-[11px] text-muted-foreground mb-2 leading-snug">
        30 minutos depois do pedido concluído, a CLEO convida o cliente a avaliar pelo WhatsApp, com uma mensagem
        diferente a cada vez.
      </p>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
        {MODULOS.map((mod) => {
          const checked = value.includes(mod.id);
          const Icon = mod.icon;
          return (
            <button
              key={mod.id}
              type="button"
              onClick={() => onToggle(mod.id)}
              aria-pressed={checked}
              data-e2e={`modulo-${mod.id}`}
              className={[
                "relative px-3 py-2.5 rounded-xl border-2 flex items-center gap-2 transition-all text-left",
                checked
                  ? "border-amber-500 bg-amber-500/10"
                  : "border-border bg-background hover:border-amber-500/40 hover:bg-amber-500/5",
              ].join(" ")}
            >
              <div className={[
                "w-8 h-8 rounded-lg flex items-center justify-center shrink-0 transition-colors",
                checked ? "bg-amber-500 text-white" : "bg-muted text-muted-foreground",
              ].join(" ")}>
                <Icon className="w-4 h-4" />
              </div>
              {/* Quebra em 2 linhas no celular em vez de cortar "Cardápio Di…" */}
              <div className="text-sm font-semibold leading-tight flex-1 min-w-0 pr-3">{mod.label}</div>
              {checked && (
                <div className="absolute top-1.5 right-1.5 w-4 h-4 rounded-full bg-amber-500 flex items-center justify-center">
                  <Check className="w-3 h-3 text-white" strokeWidth={3} />
                </div>
              )}
            </button>
          );
        })}
      </div>
      <div className="mt-2 flex gap-2 rounded-xl bg-muted/50 px-3 py-2 text-[11px] text-muted-foreground leading-snug" data-e2e="aviso-presencial">
        <MessageCircle className="w-3.5 h-3.5 shrink-0 mt-px text-amber-600" />
        <span>
          <strong className="text-foreground">Mesas, Balcão, Totem, Comandas e Mesa QR</strong> só recebem se o cliente
          escreveu para a loja no WhatsApp nos últimos 30 dias. Quem só deu o telefone no caixa não é chamado: puxar
          conversa com quem nunca escreveu faz o WhatsApp bloquear o número da loja.
        </span>
      </div>
    </section>
  );
}
